// Scoped utilities for the legacy Old Dashboard module. Everything ported from
// portal's shared/utils/common.tsx that this module depends on, so deprecating
// means deleting this directory. Do NOT add new call sites outside oldDashboard.

import { httpRequest } from "@services/http";

export {
    formatDateCharts,
    getFiltersDate,
    numberFormat,
} from "@/shared/utils/common";

export function moneyFormat(price: number): string {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }).format(price);
}

export function kpiConfig(header: string) {
    let realHeader = "Result";
    let icon = "bi-graph-up";
    let color = "text-bg-info";

    if (header === "Result") {
        realHeader = "Paid Result";
        icon = "bi-graph-up-arrow";
        color = "text-bg-success";
    }
    return { color, realHeader, icon };
}

/**
 * One GET against the Legacy Dashboard's reporting API on the platform server, which serves
 * the routes ported from the old platform out of the frozen OP warehouse (MPN-1976), through
 * the shared http client and the platform token. The old platform itself is no longer a
 * source (MPN-1977).
 */
export function legacyReportingGet(path: string): Promise<any> {
    return httpRequest<any>(`${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/legacy_dashboard/reporting/${path}`);
}
